/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import Swiper from 'swiper/swiper-bundle';

var peSwiper = new Swiper('.peSwiper', {
  autoplay: {
    delay: 5000,
  },
  rewind: true,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});



// WEBPACK FOOTER //
// ./scripts/block-slider.js